import React, { useState, useEffect } from 'react';
import SEO from '../SEO';
import { FaUserAlt, FaHeadphonesAlt } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import './HomePage.css';
import "./Footer.css";
import { motion } from "framer-motion";
import TestimonialsScroll from './TestimonialsScroll';
import FeaturedArtist from './FeaturedArtist';
import NavigationBar from '../NavigationBar';
import Footer from './Footer';
import ImageSlider from './ImageSlider';
import FeaturedBands from './FeaturedBands';
import FeaturedVenues from './FeaturedVenues';
import CommunitySection from './CommunitySection';
import VenuePromoSection from './VenuePromoSection';
import BandPromoSection from './BandPromoSection';

import {
  Music
} from "lucide-react";


const HomePage = () => {
  const navigate = useNavigate();
  const [galleryMedia, setGalleryMedia] = useState([]);
  // Show popup after 3 seconds


  const handleHireArtistClick = () => {
    navigate('/login');
  };

  const JoinAsArtist = () => {
    navigate('/login', { state: { signup: true, artist: true } });
  };

  // Helper to convert Google Drive links to direct image links and proxy through backend
  const getImageSrc = (url) => {
    if (!url) return null;
    let match = url.match(/(?:file\/d\/|open\?id=|uc\?id=)([\w-]+)/);
    if (!match) {
      match = url.match(/[?&]id=([\w-]+)/);
    }
    let directUrl = url;
    if (match && match[1]) {
      directUrl = `https://drive.google.com/uc?export=view&id=${match[1]}`;
    }
    // Always proxy through backend for CORS
    return `https://api.musicalmeet.com/api/proxy-image?url=${encodeURIComponent(directUrl)}`;
  };



  useEffect(() => {
    // Use static media from public folder
    const publicImages = [
      '/gallary-photos/gp1.avif',
      '/gallary-photos/gp2.avif',
      '/gallary-photos/gp3.avif',
      '/gallary-photos/gp4.avif',
      '/gallary-photos/gp5.avif',
      // Add more image paths as needed
    ];
    const publicVideos = [
      // Example: '/sample-video.mp4', // Add video files to public folder and reference here
    ];
    let allGalleryMedia = [];
    allGalleryMedia = allGalleryMedia.concat(
      publicImages.map(src => ({ type: 'image', src }))
    );
    allGalleryMedia = allGalleryMedia.concat(
      publicVideos.map(src => ({ type: 'video', src }))
    );
    // Shuffle the array to get random media
    for (let i = allGalleryMedia.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [allGalleryMedia[i], allGalleryMedia[j]] = [allGalleryMedia[j], allGalleryMedia[i]];
    }
    setGalleryMedia(allGalleryMedia);
  }, []);

  const [current, setCurrent] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  const questions = [
    {
      a: "Book and manage live musicians for events, parties, or online sessions—all in one place."
    },
    {
      a: "Musical Meet is a platform to discover, connect, and collaborate with talented artists who bring music to life everywhere."
    },
    {
      a: "Click the 'Join as Artist' button, set up your profile, and share your passion with music lovers worldwide effortlessly."
    },
    {
      a: "Browsing, exploring, and connecting with artists is completely free, with optional premium features for extra benefits."
    },
    {
      a: "Book a solo musician, a full band, or multiple performers for your event, without any limitations at all."
    },
    {
      a: "Anywhere and anytime! Whether it’s a live event, private party, or online session, Musical Meet is always ready for you."
    },
    {
      a: "we make finding the perfect artist simple, fast, and unforgettable—so your event always hits the perfect note."
    }
  ];

  // Auto slide every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % questions.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden"; // page scroll disable
    } else {
      document.body.style.overflow = "auto";   // page scroll enable
    }
  }, [isOpen]);

  return (
    <div className='home-page'>
      <SEO
        title="Discover & Book Live Musicians Near You"
        description="Browse musician profiles, book live performances, and connect with artists for events, parties, weddings, and more. Join MusicalMeet today."
        path="/"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: 'MusicalMeet — Discover & Book Live Musicians',
          url: 'https://musicalmeet.com/',
          description: 'Browse musician profiles, book live performances, and connect with artists for any occasion.'
        }}
      />
      <>
        <NavigationBar hideProfile />

        {/* ...existing code... */}

        <div id='imgDiv' className="relative w-full pb-0 overflow-hidden flex items-center justify-center">
          {/* Background Image */}
          <img
            alt="Background"
            className="absolute inset-0 w-full h-full z-0 scale-105"
            style={{ filter: 'brightness(0.45) saturate(1.1)' }}
            src="/BACKGROUND.avif"
            fetchpriority="high"
            decoding="async"
          />
          {/* Gradient fade into page bg */}
          <div className="absolute inset-0 z-[1]" style={{ background: 'linear-gradient(to bottom, rgba(15,23,42,0.1) 0%, rgba(15,23,42,0.25) 55%, rgba(15,23,42,1) 100%)' }} />
          {isOpen && (
            <div className="fixed inset-0 bg-black/55 backdrop-blur-md flex items-center justify-center z-[9999]">

              {/* Chat Box */}
              <div style={{
                background: 'linear-gradient(135deg, #1E1B4B 0%, #0F0F23 100%)',
              }} className="w-[380px] max-h-[90vh] text-white rounded-xl p-5 flex flex-col relative shadow-2xl border border-white/10">

                {/* Header with Avatar */}
                <div className="flex items-center justify-between mb-4 border-b border-gray-600 pb-2">
                  {/* Left Section: Icon + Title */}
                  <div className="flex items-center space-x-3">
                    {/* Icon Box */}
                    <div className="flex items-center justify-center bg-gradient-to-r from-indigo-600 to-green-500 w-10 h-10 sm:w-12 sm:h-12 rounded-xl shadow-md">
                      <Music className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
                    </div>

                    {/* Title */}
                    <h3
                      className="text-lg sm:text-xl font-semibold text-white"
                      style={{ fontFamily: "Gilroy-semiBold" }}
                    >
                      Musical Meet Support
                    </h3>
                  </div>

                  {/* Close Button */}
                  <button
                    onClick={() => setIsOpen(false)}
                    aria-label="Close support guide"
                    className="flex items-center justify-center w-8 h-8 sm:w-9 sm:h-9 rounded-lg bg-white/10 text-white text-lg hover:bg-red-500/80 transition-all duration-200"
                  >
                    ✖
                  </button>
                </div>

                {/* Scrollable Chat Content */}
                <div className="flex-1 overflow-y-auto pr-1">
                  <h4 className="text-lg font-semibold mb-2" style={{ fontFamily: "Gilroy-semiBold" }}>
                    🎯 What You Can Do :
                  </h4>
                  <ul className="list-none pl-0 leading-7 text-gray-300" style={{ fontFamily: "Gilroy-semiBold" }}>
                    <li>🎤 Discover and connect with live musicians and bands</li>
                    <li>📅 Book artists directly for events, parties, or online sessions</li>
                    <li>💬 View artist profiles and customer feedback at a glance</li>
                    <li>⭐ See trending & top-rated performers</li>
                    <li>🆔 Quick OTP authentication for secure login</li>
                    <li>📸 Explore galleries and event snapshots</li>
                    <li>🌐 Full mobile & desktop responsive experience</li>
                  </ul>

                  <h4 className="text-lg font-semibold mt-5 mb-2" style={{ fontFamily: "Gilroy-semiBold" }}>
                    Tips to Get Started :
                  </h4>
                  <p className="text-gray-400 leading-relaxed" style={{ fontFamily: "Gilroy-semiBold" }}>
                    • Tap “Join as Artist” to build your profile and showcase your music.<br />
                    • Use “Hire an Artist” to book performances—solo or bands—for any occasion.<br />
                    • Browse the gallery to find inspiration from past events.<br />
                    • Check for FAQs and top-rated listings to make smart choices.<br />
                    • Always explore trending artists for the most updated performances.
                  </p>

                </div>
              </div>
            </div>
          )}

          <style>{`
            @media (max-width: 640px) {
              .mm-guide-btn {
                top: calc(72px + env(safe-area-inset-top)) !important;
                left: 12px !important;
                bottom: auto !important;
                transform: none !important;
                width: auto;
                max-width: none;
                display: flex;
                justify-content: center;
                padding: 8px 14px !important;
                font-size: 13px !important;
                min-height: 36px !important;
              }
            }
          `}</style>

          {/*  guide button*/}
          <button
            onClick={() => setIsOpen(!isOpen)}
            aria-label="Open platform guide"
            className="mm-guide-btn"
            style={{
              position: "absolute",
              bottom: '4%',
              left: '5%',
              padding: '10px 22px',
              borderRadius: "8px",
              border: "1px solid rgba(255,255,255,0.2)",
              backgroundColor: "rgba(67, 56, 202, 0.2)",
              color: "rgba(255, 255, 255, 0.9)",
              fontSize: "15px",
              fontWeight: "600",
              fontFamily: "Poppins, sans-serif",
              cursor: "pointer",
              transition: "all 0.2s ease",
              boxShadow: "0 4px 16px rgba(0,0,0,0.3)",
              backdropFilter: "blur(8px)",
              minHeight: "44px",
              zIndex: '123'
            }}
            onMouseEnter={e => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = "0 6px 24px rgba(67,56,202,0.4)";
              e.currentTarget.style.backgroundColor = "rgba(67, 56, 202, 0.4)";
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,0.3)";
              e.currentTarget.style.backgroundColor = "rgba(67, 56, 202, 0.2)";
            }}
          >
            Guide →
          </button>

          {/* Content */}
          <motion.div
            id="h1div"
            className="z-20 text-center px-6 py-20 w-full max-w-4xl mx-auto"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >

            {/* Heading */}
            <motion.h1
              style={{ fontFamily: 'Gilroy-semiBold', fontWeight: 800, lineHeight: 1.1, color: '#fff', marginBottom: 20, marginTop: 10, fontSize: 'clamp(2.6rem, 6vw, 4.5rem)' }}
              initial={{ opacity: 0, y: -30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3, duration: 0.7 }}
            >
              Connecting People<br />
              <span style={{ background: 'linear-gradient(135deg, #818cf8, #c4b5fd)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>
                To Music With Music
              </span>
            </motion.h1>

            {/* Subtitle */}
            <motion.p
              style={{ color: '#94a3b8', fontSize: 'clamp(1rem, 2vw, 1.25rem)', fontFamily: 'Poppins, sans-serif', lineHeight: 1.7, marginBottom: 40 }}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.55, duration: 0.6 }}
            >
              Celebrate the joy of music — discover, book and connect with<br className="hidden sm:block" /> talented artists for any occasion, anywhere in India.
            </motion.p>

            {/* CTAs */}
            <motion.div
              className="flex flex-col sm:flex-row items-center justify-center gap-4"
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.75, duration: 0.6 }}
            >
              <motion.button
                onClick={JoinAsArtist}
                whileHover={{ scale: 1.04 }}
                whileTap={{ scale: 0.96 }}
                style={{ display: 'flex', alignItems: 'center', gap: 10, background: '#374EA9', color: '#fff', border: 'none', borderRadius: 12, padding: '14px 28px', fontFamily: 'Gilroy-semiBold', fontSize: '1rem', cursor: 'pointer', boxShadow: '0 6px 24px rgba(55,78,169,0.45)', transition: 'background 0.2s', minHeight: 50 }}
                onMouseEnter={e => e.currentTarget.style.background = '#4a62d6'}
                onMouseLeave={e => e.currentTarget.style.background = '#374EA9'}
              >
                <FaUserAlt style={{ fontSize: '0.9rem' }} />
                Join as Artist
              </motion.button>

              <motion.button
                onClick={handleHireArtistClick}
                whileHover={{ scale: 1.04 }}
                whileTap={{ scale: 0.96 }}
                style={{ display: 'flex', alignItems: 'center', gap: 10, background: 'rgba(255,255,255,0.08)', color: '#fff', border: '1px solid rgba(255,255,255,0.25)', borderRadius: 12, padding: '14px 28px', fontFamily: 'Gilroy-semiBold', fontSize: '1rem', cursor: 'pointer', backdropFilter: 'blur(8px)', minHeight: 50 }}
                onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.14)'; }}
                onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.08)'; }}
              >
                <FaHeadphonesAlt style={{ fontSize: '0.95rem' }} />
                Hire An Artist
              </motion.button>

              <motion.button
                onClick={() => navigate('/jamming')}
                whileHover={{ scale: 1.04 }}
                whileTap={{ scale: 0.96 }}
                style={{ display: 'flex', alignItems: 'center', gap: 10, background: 'transparent', color: '#a5b4fc', border: '1px solid rgba(129,140,248,0.35)', borderRadius: 12, padding: '14px 24px', fontFamily: 'Gilroy-semiBold', fontSize: '1rem', cursor: 'pointer', minHeight: 50 }}
                onMouseEnter={e => e.currentTarget.style.background = 'rgba(129,140,248,0.1)'}
                onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
              >
                Jamming Sessions
              </motion.button>
            </motion.div>

            {/* Rotating tagline */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 1.0, duration: 0.7 }}
              style={{ marginTop: 48, marginBottom: 8 }}
            >
              <div style={{ background: 'rgba(255,255,255,0.04)', color: '#cbd5e1', padding: '1rem 1.5rem', borderRadius: 12, border: '1px solid rgba(255,255,255,0.08)', backdropFilter: 'blur(12px)', fontSize: '0.95rem', fontFamily: 'Poppins, sans-serif', lineHeight: 1.6, maxWidth: 640, margin: '0 auto' }}>
                {questions[current].a}
              </div>
            </motion.div>
          </motion.div>
        </div>

        <FeaturedArtist />
        <BandPromoSection />
        <FeaturedBands />
        <VenuePromoSection />
        <FeaturedVenues />
        <CommunitySection />
        <TestimonialsScroll />

        <Footer id="footer" />
      </>
    </div >
  );
};

export default HomePage;